import { render, staticRenderFns } from "./AddInvestment.vue?vue&type=template&id=68128369&"
import script from "./AddInvestment.vue?vue&type=script&lang=js&"
export * from "./AddInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports